import Sublime from "./components/sublime/Sublime";

import "./App.css";

function App() {
  return <Sublime />;
}

export default App;
